(function () {
  'use strict';

  var COPY = {
    nl: {
      eyebrow: 'MUSKLE · MJ App',
      title: 'Creatine Gebruiksgids',
      intro:
        'Krijg een praktische creatine-richtlijn op basis van je doel, training en voorkeur.',
      accountNote: 'Geen account nodig. Log later in om je richtlijn op te slaan.',
      backLabel: 'Terug naar MJ Apps',
      goalLabel: 'Doel',
      goalStrength: 'Kracht & prestaties',
      goalMuscle: 'Spiermassa ondersteunen',
      goalGeneral: 'Algemene routine',
      trainingLabel: 'Trainingsfrequentie',
      training02: '0–2 dagen',
      training34: '3–4 dagen',
      training5: '5+ dagen',
      preferenceLabel: 'Voorkeur',
      prefSimple: 'Simpel dagelijks gebruik',
      prefLoading: 'Laadfase uitleg',
      prefSensitive: 'Gevoelige maag',
      showBtn: 'Toon mijn richtlijn',
      resultTitle: 'Jouw creatine-richtlijn',
      resultEmpty: 'Kies je opties en klik op toon richtlijn om je praktische creatine-advies te zien.',
      approachHeading: 'Aanbevolen aanpak',
      approach: {
        strength:
          'Voor kracht en prestaties is dagelijks creatine monohydraat een praktische ondersteuning. Het doel is een stabiele routine, niet een perfect tijdstip.',
        muscle:
          'Voor spiermassa ondersteunen kan creatine helpen als vaste aanvulling naast training en voeding. Dit is geen verplicht supplement en geen garantie op resultaat.',
        general:
          'Voor een algemene routine is dagelijks gebruik van creatine monohydraat een eenvoudige, praktische optie.',
      },
      trainingNote: {
        low: 'Met weinig training blijft dagelijks gebruik — ook op rustdagen — de basis.',
        mid: 'Met regelmatige training past dagelijks gebruik goed, inclusief op rustdagen.',
        high: 'Met veel training blijft dezelfde dagelijkse richtlijn gelden; consistentie is belangrijker dan extra dosering.',
      },
      dailyHeading: 'Dagelijkse hoeveelheid',
      dailyMain:
        'Praktische richtlijn: 3–5 g creatine monohydraat per dag. Neem het dagelijks, ook op rustdagen. Consistentie is belangrijker dan het exacte tijdstip.',
      dailySensitive:
        'Bij een gevoelige maag: start met 3 g per dag, neem het met voldoende water en eventueel bij een maaltijd.',
      timingHeading: 'Timing',
      timing:
        'Je kunt creatine nemen bij een maaltijd, na training, of op een vast moment van de dag. Kies vooral een moment dat je volhoudt.',
      loadingHeading: 'Laadfase (optioneel)',
      loadingOptional:
        'Een laadfase kan sneller de creatinevoorraad aanvullen, maar is niet verplicht. Voor deze gids houden we dagelijks gebruik simpel en praktisch.',
      safetyNote:
        'Deze gids is bedoeld voor gezonde volwassenen, geen medisch advies. Bij nierproblemen, medicatiegebruik, zwangerschap, borstvoeding of twijfel: overleg met een arts of diëtist.',
      sourceNote:
        'Gebaseerd op sportvoedingsrichtlijnen zoals ISSN en EFSA. Creatine monohydraat is de standaardvorm in de meeste richtlijnen.',
    },
    en: {
      eyebrow: 'MUSKLE · MJ App',
      title: 'Creatine Guide',
      intro: 'Get practical creatine guidance based on your goal, training and preference.',
      accountNote: 'No account needed. Later you can log in to save your guidance.',
      backLabel: 'Back to MJ Apps',
      goalLabel: 'Goal',
      goalStrength: 'Strength & performance',
      goalMuscle: 'Support muscle gain',
      goalGeneral: 'General routine',
      trainingLabel: 'Training frequency',
      training02: '0–2 days',
      training34: '3–4 days',
      training5: '5+ days',
      preferenceLabel: 'Preference',
      prefSimple: 'Simple daily use',
      prefLoading: 'Loading phase explanation',
      prefSensitive: 'Sensitive stomach',
      showBtn: 'Show my guidance',
      resultTitle: 'Your creatine guidance',
      resultEmpty: 'Choose your options and click show guidance to see your practical creatine advice.',
      approachHeading: 'Recommended approach',
      approach: {
        strength:
          'For strength and performance, daily creatine monohydrate is practical support. The goal is a stable routine, not a perfect timing.',
        muscle:
          'To support muscle gain, creatine can help as a consistent addition alongside training and nutrition. It is not a required supplement and not a guarantee of results.',
        general:
          'For a general routine, daily creatine monohydrate is a simple, practical option.',
      },
      trainingNote: {
        low: 'With little training, daily use — including on rest days — remains the foundation.',
        mid: 'With regular training, daily use fits well, including on rest days.',
        high: 'With heavy training, the same daily guideline applies; consistency matters more than extra dosing.',
      },
      dailyHeading: 'Daily amount',
      dailyMain:
        'Practical guideline: 3–5 g creatine monohydrate per day. Take it daily, including rest days. Consistency matters more than exact timing.',
      dailySensitive:
        'With a sensitive stomach: start with 3 g per day, take it with enough water and optionally with a meal.',
      timingHeading: 'Timing',
      timing:
        'You can take creatine with a meal, after training, or at a fixed time of day. Choose a moment you can stick with.',
      loadingHeading: 'Loading phase (optional)',
      loadingOptional:
        'A loading phase can fill creatine stores faster, but is not required. This guide keeps daily use simple and practical.',
      safetyNote:
        'This guide is intended for healthy adults, not medical advice. If you have kidney problems, use medication, are pregnant, breastfeeding or have doubts: consult a doctor or dietitian.',
      sourceNote:
        'Based on sports nutrition guidance such as ISSN and EFSA. Creatine monohydrate is the standard form in most guidelines.',
    },
  };

  function init(root) {
    if (!root || root.dataset.mjCreatineGuideInit === '1') return;
    root.dataset.mjCreatineGuideInit = '1';

    var lang = root.dataset.defaultLang === 'en' ? 'en' : 'nl';
    var els = {
      langBtns: root.querySelectorAll('[data-mj-lang]'),
      back: root.querySelector('[data-mj-copy="backLabel"]'),
      showBtn: root.querySelector('[data-mj-action="show"]'),
      resultEmpty: root.querySelector('[data-mj-result-empty]'),
      resultPanel: root.querySelector('[data-mj-result-panel]'),
      resultApproach: root.querySelector('[data-mj-result-approach]'),
      resultDaily: root.querySelector('[data-mj-result-daily]'),
      resultTiming: root.querySelector('[data-mj-result-timing]'),
      loadingBlock: root.querySelector('[data-mj-result-loading]'),
      loadingText: root.querySelector('[data-mj-result-loading-text]'),
    };

    function t(key) {
      var parts = key.split('.');
      var val = COPY[lang];
      for (var i = 0; i < parts.length; i += 1) {
        if (!val) return key;
        val = val[parts[i]];
      }
      return val || key;
    }

    function getSelected(name) {
      var nodes = root.querySelectorAll('[data-mj-input="' + name + '"]');
      for (var i = 0; i < nodes.length; i += 1) {
        if (nodes[i].checked) return nodes[i].value;
      }
      return '';
    }

    function applyCopy() {
      root.querySelectorAll('[data-mj-copy]').forEach(function (node) {
        var key = node.getAttribute('data-mj-copy');
        if (!key || key === 'backLabel') return;
        var text = t(key);
        if (typeof text === 'string') node.textContent = text;
      });

      if (els.back) els.back.textContent = t('backLabel');
      if (els.showBtn) els.showBtn.textContent = t('showBtn');

      root.querySelectorAll('[data-mj-option="goal"]').forEach(function (node) {
        var opt = node.getAttribute('data-mj-option-value');
        if (opt === 'strength') node.textContent = t('goalStrength');
        if (opt === 'muscle') node.textContent = t('goalMuscle');
        if (opt === 'general') node.textContent = t('goalGeneral');
      });

      root.querySelectorAll('[data-mj-option="training"]').forEach(function (node) {
        var opt = node.getAttribute('data-mj-option-value');
        if (opt === '0-2') node.textContent = t('training02');
        if (opt === '3-4') node.textContent = t('training34');
        if (opt === '5+') node.textContent = t('training5');
      });

      root.querySelectorAll('[data-mj-option="preference"]').forEach(function (node) {
        var opt = node.getAttribute('data-mj-option-value');
        if (opt === 'simple') node.textContent = t('prefSimple');
        if (opt === 'loading') node.textContent = t('prefLoading');
        if (opt === 'sensitive') node.textContent = t('prefSensitive');
      });

      els.langBtns.forEach(function (btn) {
        var isActive = btn.getAttribute('data-mj-lang') === lang;
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        btn.classList.toggle('mj-app__lang-btn--active', isActive);
      });

      root.setAttribute('data-mj-lang', lang);
    }

    function showGuidance() {
      var goal = getSelected('goal') || 'general';
      var training = getSelected('training') || '3-4';
      var preference = getSelected('preference') || 'simple';

      var trainKey = training === '0-2' ? 'low' : training === '5+' ? 'high' : 'mid';

      if (els.resultApproach) {
        els.resultApproach.textContent =
          t('approach.' + goal) + ' ' + t('trainingNote.' + trainKey);
      }

      if (els.resultDaily) {
        els.resultDaily.textContent =
          preference === 'sensitive' ? t('dailySensitive') : t('dailyMain');
      }

      if (els.resultTiming) els.resultTiming.textContent = t('timing');

      if (els.loadingBlock && els.loadingText) {
        var showLoading = preference === 'loading';
        els.loadingBlock.hidden = !showLoading;
        if (showLoading) els.loadingText.textContent = t('loadingOptional');
      }

      if (els.resultEmpty) els.resultEmpty.hidden = true;
      if (els.resultPanel) els.resultPanel.hidden = false;
      root.classList.add('mj-app--has-result');
    }

    els.langBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.getAttribute('data-mj-lang');
        if (next === 'nl' || next === 'en') {
          lang = next;
          applyCopy();
          if (root.classList.contains('mj-app--has-result')) showGuidance();
        }
      });
    });

    if (els.showBtn) {
      els.showBtn.addEventListener('click', showGuidance);
    }

    applyCopy();
  }

  document.querySelectorAll('[data-mj-creatine-guide-app]').forEach(init);
})();
